import "./index.css";
import App from "./App";
import AppProviders from "api/AppProviders";
import React, { useEffect, useState } from "react";
import Translation from "./lang/translation.json";
import reportWebVitals from "./reportWebVitals";
import { IntlProvider } from "react-intl";
import { createRoot } from "react-dom/client";
import { useUserContext } from "api/user/UserProvider";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "api/user/msalConfig";
import { MsalEventListener } from "api/user/MsalEventListener";

const CustomIntlProvider = ({ children }) => {
  React.Component.defaultProps = { key: "default_key" };

  const { lang } = useUserContext();
  const [messages, setMessages] = useState(Translation.fr);
  const [currentLang, setCurrentLang] = useState(lang);
  useEffect(() => {
    if (lang !== currentLang) {
      lang === "fr" ? setMessages(Translation.fr) : setMessages(Translation.en);
      setCurrentLang(lang);
      const html = document.querySelector("html");
      html.attributes.lang.value = lang;
    }
  }, [lang]);

  return (
    <IntlProvider locale={lang} messages={messages}>
      {children}
    </IntlProvider>
  );
};
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <MsalProvider instance={msalInstance}>
    <MsalEventListener>
      <AppProviders>
        <CustomIntlProvider>
          <App />
        </CustomIntlProvider>
      </AppProviders>
    </MsalEventListener>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
